// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Annie_carouselContainer__NSExm","textContainer":"Annie_textContainer__sazXL"};